import React, { Fragment, useEffect, useRef, useState } from 'react';
import { Progress, Tag } from 'antd';
import { connect } from 'react-redux';
import moment from 'moment';

import { getChartDataWithoutSelection, getChartDataWithSelection } from '../../ChartCalls';
import { progressBarMock } from '../../../Mock/MockJson';
import { ErrorComponent, NoRecordComponent } from '../../Utils';
import '../../CSS/style.css';
import { config } from '../../constant';

const ProgressBar = (props) => {
  const [percent, setPercent] = useState(0);
  // const [type] = useState('circle');
  // const [title] = useState('');
  // const [translationCache] = useState(props.translationCache || []);
  const [refreshDateTime, setRefreshDateTime] = useState(moment());
  const [errorInAPI, setErrorInAPI] = useState(false);
  const [noDataInDB, setNoDataInDB] = useState(false);

  let timeTicket = useRef(null);
  const requestCheck = useRef(true);
  const abortController = useRef(new window.AbortController());

  // Helper function for data fetching
  const getData = async () => {
    let json = [];
    let { graphprops } = props;
    let error = false;
    let noData = false;
    requestCheck.current = false;
    error = false;
    noData = false;

    if (graphprops && graphprops.enableMock && graphprops.enableMock === true) {
      json = progressBarMock;
      requestCheck.current = true;
    } else {
      if (
        graphprops &&
          ((graphprops.DashboardLevelSelection === 'datePicker' ||
            graphprops.GraphLevelSelection === 'datePicker') &&
            selectionDate) || 
          (
            (graphprops.DashboardLevelSelection === 'monthPicker' ||
              graphprops.GraphLevelSelection === 'monthPicker') &&
            selectionMonth) || 
          (
            (graphprops.DashboardLevelSelection === 'dateRangePicker' ||
              graphprops.GraphLevelSelection === 'dateRangePicker') &&
            selectionDateRange) || 
          (
            (graphprops.DashboardLevelSelection === 'dateMonthYearPicker' ||
              graphprops.GraphLevelSelection === 'dateMonthYearPicker') &&
            dayMonthYear) ||
          (
            (graphprops.DashboardLevelSelection === 'deviceSelection' ||
              graphprops.GraphLevelSelection === 'deviceSelection') &&
            DeviceCode)
      ) {
        json = await getChartDataWithSelection({
          graphprops,
          selectionDate,
          selectionMonth,
          selectionDateRange,
          DeviceCode,
          dayMonthYear,
          abortController: abortController.current,
          currentTimeZone,
        });
        requestCheck.current = true;
      } else if (
        graphprops.GraphLevelSelection === 'none' ||
        graphprops.DashboardLevelSelection   === 'none'
      ){
        json = await getChartDataWithoutSelection({
         graphprops,
            abortController: abortController.current,
            DeviceCode,
            TimeZone: currentTimeZone,
        });
        requestCheck.current = true;
      }
    }

    if (
      (json && json.message) ||
      (Array.isArray(json) && json.length === 0 && graphprops.enableMock !== true)
    ) {
      if (json.message) {
        error = true;
      } else if (json.length === 0) {
        noData = true;
      }
      setErrorInAPI(error);
      setNoDataInDB(noData);
    } else {
      if (json && json[0] && json[0].Value) {
        setPercent(json[0]?.Value);
        setRefreshDateTime(moment());
      }else{
        setPercent(json?.Value);
        setRefreshDateTime(moment());
      }
      setErrorInAPI(error);
      setNoDataInDB(noData);
    }
  };

  const {
    graphprops,
    selectionDate,
    selectionMonth,
    DeviceCode,
    selectionDateRange,
    dayMonthYear,
    currentTimeZone,
  } = props;

  useEffect(() => {
    if (timeTicket.current) {
      clearInterval(timeTicket.current);
    }
    let refreshTime = graphprops?.refreshTime ? graphprops.refreshTime * 60000 : config.defaultRefreshTime;
    timeTicket.current = setInterval(() => {
      if (requestCheck.current) {
        getData();
      }
    }, refreshTime);

    return () => {
      abortController.current.abort();
      clearInterval(timeTicket.current);
    };
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    getData();
  }, [
    selectionDate,
    selectionMonth,
    selectionDateRange,
    DeviceCode,
    dayMonthYear,
    props.translationCache
  ]);

  return (
    <Fragment>
      {graphprops && graphprops.checked === true ? (
        <Tag className="graphTag" color="blue">
          {refreshDateTime ? moment(refreshDateTime).format('YYYY-MM-DD HH:mm:ss') : ''}
        </Tag>
      ) : null}
      {noDataInDB === true || errorInAPI === true ? (
        noDataInDB === true ? (
          <NoRecordComponent />
        ) : (
          <ErrorComponent />
        )
      ) : (
        <div className="progressbar">
          {graphprops[graphprops.graph] && graphprops[graphprops.graph].barType === 'line' ? (
            <div className="progressbarline">
              <Progress
                strokeWidth={20}
                strokeColor={{
                  '0%': '#108ee9',
                  '50%': '#87d068'
                }}
                style={{
                  color: props.graphprops.titleColor
                    ? props.graphprops.titleColor
                    : props.theme.algorithm === "dark" ? 'white' : 'black'
                }}
                type={
                  graphprops[graphprops.graph] && graphprops[graphprops.graph].barType
                    ? graphprops[graphprops.graph].barType
                    : ''
                }
                percent={percent}
                status="active"
              />
            </div>
          ) : (
            <div className="progressbarcircles">
              <Progress
                style={{ color: props.graphprops.titleColor }}
                type={
                  graphprops[graphprops.graph] && graphprops[graphprops.graph].barType
                    ? graphprops[graphprops.graph].barType
                    : ''
                }
                percent={percent}
                status="active"
              />
            </div>
          )}
        </div>
      )}
    </Fragment>
  );
};
const mapStateToProps = (state) => {
  return {
    theme: state.ThemeReducer,
    translationCache: state.TranslationReducer.translationCache,
    currentTimeZone: state.LayoutReducer.currentTimeZone
  };
};
export default connect(mapStateToProps)(ProgressBar);
